import React, { useState, useEffect } from "react";
import Container from "../../../components/Container/Container";
import CustomButton from "../../../components/commons/CustomBtn";
import "./immoHeader.css";
import { ReactComponent as Lots } from "../../../components/assets/Lots.svg";
import { ReactComponent as Programs } from "../../../components/assets/programs.svg";
import { ReactComponent as Carte } from "../../../components/assets/carte.svg";
import CustomDropdown from "../../../components/commons/CustomDropDown";
import Filters from "./Filter";
import DeepSearch from "./DeepSearch";
import { useDispatch } from "react-redux";
import { openModal } from "../../../redux/actions/modalActions";
import AddSecteurModal from "../../backOffice/components/AddSecteurModal";
import { ReactComponent as Settings } from "../../../components/assets/filterSettings.svg";
import EditCollaboratorModal from "../../backOffice/components/EditCollaboratorModal";
import debounce from "../../../utils/debounce";

const ImmoHeader = ({
  activeView,
  setActiveView,
  carte = true,
  lots = true,
  programmes = true,
  deepSearch = false,
  filterInput,
  setFilterInput,
  addSecteur = false,
  handleSearch,
  backOffice = false,
  filterBtn = true,
}) => {
  const dispatch = useDispatch();
  const applyFilters = (filters) => {
    console.log("Applied Filters:", filters);
  };

  const resetFilters = () => {
    console.log("Filters reset");
  };

  // Create a debounced version of handleSearch
  const debouncedSearch = debounce(() => {
    if (filterInput.trim() !== "") {
      handleSearch();
    }
  }, 200);

  // Effect to call debounced search when filterInput changes
  useEffect(() => {
    if (filterInput.trim() !== "") {
      debouncedSearch();
    }
  }, [filterInput]);

  const handleInputChange = (e) => {
    const { value } = e.target;
    setFilterInput(value);
    // The search will be triggered by the useEffect above
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      // Immediate search on Enter key
      handleSearch();
    }
  };
  const dropdownOptionsForLots = [
    { value: "updatedAt", label: "Tout" },
    { value: "price_total", label: "Prix" },
    { value: "rent_profitability", label: "Rentabilité estimée" },
    { value: "reference", label: "Référence de lot" },
    { value: "typology", label: "Typologie" },
    { value: "surface", label: "Surface habitable" },
    { value: "weighted_surface", label: "Surface Totale" },
    { value: "parking_count", label: "Nombre de parkings" },
    { value: "floor", label: "Étage" },
  ];
  const dropdownOptionsForProgrammes = [
    { value: "updatedAt", label: "Tout" },
    { value: "name", label: "Nom" },
    { value: "is_actable", label: "Actabilité" },
    { value: "delivery_date", label: "Date de Livraison" },
    { value: "zone_fiscale", label: "Zone fiscale" },
    { value: "promoteur.name", label: "Promoteur" },
  ];
  const ViewSetter = (type) => {
    setActiveView(type);
  };
  const handleDeepSearch = () => {
    dispatch(
      openModal({
        title: "Recherche avancée",
        content: <DeepSearch />,
      })
    );
  };
  const openAddSecteurModal = (documentId) => {
    dispatch(
      openModal({
        title: "Ajouter un secteur",
        content: <AddSecteurModal documentId={documentId} />,
      })
    );
  };
  const addUser = () => {
    dispatch(
      openModal({
        title: "Ajouter un utilisateur",
        content: <EditCollaboratorModal isCreating={true} />,
      })
    );
  };
  return (
    <Container className="p-0">
      <div className="d-flex bg-white headerRadius5 headerContainer align-items-center justify-content-between">
        <div className="d-flex gap-3">
          <div className="d-flex align-items-center gap10 bg-white radius5 px-20 py-2px searchBar">
            <img src="./icons/search.svg" alt="search" height={16} width={16} />
            <input
              type="text"
              placeholder={
                activeView === "lots"
                  ? "Rechercher un lot"
                  : "Rechercher un programme"
              }
              className="inputSearch border-0"
              value={filterInput}
              onChange={handleInputChange}
              onKeyDown={handleKeyPress}
            />
          </div>
          {/* Search button commented out as we now use debounced search that triggers automatically
          <button
            className="border-0 bg-pink px-20 py-10 radius5 hoverOpacity"
            onClick={handleSearch}
          >
            <img
              src="./icons/search_white.svg"
              alt="search"
              height={16}
              width={16}
            />
          </button>
          */}
          {addSecteur && (
            <button
              onClick={openAddSecteurModal}
              className={`border-0 radius5 px-20 py-10 white hoverOpacity bg-pink cursor-pointer`}
            >
              Ajouter un secteur
            </button>
          )}
        </div>

        <div className="headerButtons d-flex gap3 ">
          {lots && (
            <CustomButton
              onClick={() => ViewSetter("lots")}
              label="Voir les lots"
              buttonClass={`
            ${
              activeView === "lots"
                ? "whiteSvg bg-pink white radiusTL5 radiusBL5 px-20 py-10"
                : "bg-white-grey darkGrey radiusTL5 radiusBL5 px-20 py-10"
            }`}
              labelClass=" fs13 medium text-capitalize d-none d-xxl-flex"
              icon={<Lots />}
              iconClass="immoHeaderIcons "
            />
          )}
          {programmes && (
            <CustomButton
              onClick={() => ViewSetter("programmes")}
              label="Voir les programmes"
              buttonClass={`
            ${
              activeView === "programmes"
                ? "whiteSvg bg-pink white  px-20 py-10"
                : "bg-white-grey darkGrey  px-20 py-10"
            }
             ${carte ? "" : "radiusTR5 radiusBR5"}
          `}
              labelClass=" fs13 medium text-capitalize d-none d-xxl-flex"
              icon={<Programs />}
              iconClass="immoHeaderIcons"
            />
          )}
          {carte && (
            <CustomButton
              onClick={() => ViewSetter("carte")}
              label="Voir la carte"
              buttonClass={`
            ${
              activeView === "carte"
                ? "whiteSvg bg-pink white radiusTR5 radiusBR5 px-20 py-10"
                : "bg-white-grey darkGrey radiusBR5 radiusTR5 px-20 py-10"
            }
          `}
              labelClass=" fs13 medium text-capitalize d-none d-xxl-flex"
              icon={<Carte />}
              iconClass="immoHeaderIcons"
            />
          )}
        </div>
        {backOffice ? (
          <button
            onClick={addUser}
            className={`border-0 radius5 px-20 py-10 white hoverOpacity bg-pink cursor-pointer`}
          >
            <img
              src="./icons/add-user.svg"
              alt="add-user"
              height={24}
              width={24}
            />
          </button>
        ) : (
          <>
            {" "}
            {/*    <div className=" d-flex gap10 align-items-center dropdownMenu ">
              <p>Trier par</p>
              <CustomDropdown
                options={
                  activeView === "lots"
                    ? dropdownOptionsForLots
                    : dropdownOptionsForProgrammes
                }
              />
            </div> */}
            {filterBtn && (
              <div className="filter d-flex align-items-center gap10">
                <p>Filtrer</p>
                {/*   <Filters
                  onApplyFilters={applyFilters}
                  onResetFilters={resetFilters}
                /> */}
                <button className="toggle-button  " onClick={handleDeepSearch}>
                  <Settings />
                </button>
              </div>
            )}
          </>
        )}
      </div>
    </Container>
  );
};

export default ImmoHeader;
